import React, { useRef, useEffect, useState } from "react";
import { TextareaAutosize } from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MessagePicker from "../picker";
import { getEmojiByCode } from "../../util";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  replyEmojibox: {
    right: "10px",
    position: "absolute",
    top: "15px",
    display: "flex",
    "& button": {
      position: "relative !important",
      top: "initial !important",
      right: "initial !important",
    },
  },
  editmessageContainer: {
    position: "relative",
    display: "block",
  },
}));

const EditMessage = ({ item, handleCancel, handleEditSubmit }) => {
  const classes = useStyles();
  const inputRef = useRef(null);
  const [message, setMessage] = useState(item?.text);
  const [cursorPosition, setCursorPosition] = useState(0);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.setSelectionRange(
        item?.text?.length,
        item?.text?.length
      );
      inputRef.current.scrollIntoView();
      setCursorPosition(item?.text?.length);
    }
  }, [inputRef.current]);

  const handleSend = (e) => {
    console.log("after enter click");
    console.log("print Edit button right click display tick mark:", e);
    if (message.trim()?.length > 0) {
      let _data = {
        type: "text",
        text: message,
      };
      console.log("after edit message data", _data);
      handleEditSubmit(_data);
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      console.log("print Edit button right handleEnter:", e);
      e.preventDefault();
      handleSend(e);
    }
  };

  const onSelectEmoji = (e) => {
    let emoji = getEmojiByCode(e);
    let val = [
      message?.slice(0, cursorPosition),
      emoji,
      message?.slice(cursorPosition),
    ]?.join("");
    setCursorPosition(cursorPosition + emoji.toString().length);
    setMessage(val);
  };
  return (
    <>
      <ClickAwayListener onClickAway={handleCancel}>
        <div
          className={"message_input_box " + classes.editmessageContainer}
          style={{ padding: "5px 0" }}
        >
          <TextareaAutosize
            id="msg_textarea"
            maxRows={7}
            placeholder="Type a comment"
            onChange={(e) => {
              setMessage(e.target.value);
              setCursorPosition(e.target.selectionEnd);
            }}
            onMouseUp={(e) => setCursorPosition(e.target.selectionEnd)}
            onKeyPress={handleEnter}
            value={message}
            ref={inputRef}
            autoFocus={true}
            style={{ padding: "15px 120px 10px 30px" }}
          />
          <div className={"action_btn " + classes.replyEmojibox}>
            <MessagePicker
              onSelectEmoji={onSelectEmoji}
              isEmoji={true}
              isGif={false}
            />
            <button type="button" className="send-btn" onClick={handleSend}>
              <i className="fa fa-check"></i>
            </button>
            <button type="button" className="send-btn" onClick={handleCancel}>
              <i className="fa fa-close"></i>
            </button>
          </div>
        </div>
      </ClickAwayListener>
    </>
  );
};

export default EditMessage;
